import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { FcMoneyTransfer, FcOrgUnit, FcMenu } from "react-icons/fc"; 
import { BsCashStack} from "react-icons/bs";
import { FaAward} from "react-icons/fa6";
import HandleCurrentPath from "./HandleCurrentPath";
const MobileHamburger = () => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const toggleSideMenu = () => {
    setIsSideMenuOpen(!isSideMenuOpen);

  }; 
    const closeSideMenu = () => {
        setIsSideMenuOpen(false);
    };
    const pathname = window.location.pathname;
  
  return (
    <>
     {/* Mobile menu */}

     <aside
                className={`fixed inset-y-0 z-20 flex-shrink-0 w-64 mt-16 overflow-y-auto bg-white dark:bg-gray-800 md:hidden ${isSideMenuOpen ? 'block' : 'hidden'}`}
                onClick={closeSideMenu}
            >
                <div className="py-4 text-gray-500 dark:text-gray-400">
          <Link
            className="ml-6 text-lg font-bold text-gray-800 dark:text-gray-200"
            href="#"
          >
           LuckyBox
          </Link>
          <ul className="mt-6">
                <li className="relative px-6 py-3">
                 
                <HandleCurrentPath staticPath={'/'} currentPath={pathname} />
                <Link
                    className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    <FcOrgUnit />
                    <span className="ml-4">Dashboard</span>
                </Link>
                </li>
            </ul>
          <ul className="mt-6">
     



    <li className="relative px-6 py-3">
        <HandleCurrentPath staticPath={'/deposit'} currentPath={pathname} />
        <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/deposit'} >
            <FcMoneyTransfer/>
            <span className="ml-4">Deposits </span>
        </Link>
    </li>

    <li className="relative px-6 py-3">
        <HandleCurrentPath staticPath={'/winning'} currentPath={pathname} />
        <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/winning'} >
            <BsCashStack/>
            <span className="ml-4">Winnings </span>
        </Link>
    </li>

    <li className="relative px-6 py-3">
        <HandleCurrentPath staticPath={'/rewardnomination'} currentPath={pathname} />
        <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/rewardnomination'} >
            <FaAward/>
            <span className="ml-4">Reward Nomination </span>
        </Link>
    </li>
  
 

</ul>
</div>

            </aside>
            {/* End mobile Menu */}
    <button
      className={`p-1 mr-5 -ml-1 rounded-md md:hidden focus:outline-none focus:shadow-outline-purple ${isSideMenuOpen ? 'bg-purple-500' : 'bg-transparent'}`}
      onClick={toggleSideMenu}
      aria-label="Menu"
    >

        <FcMenu/>
      {/* <svg
        className="w-6 h-6 text-white"
        aria-hidden="false"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clipRule="evenodd"
        />
      </svg> */}
    </button>
    </>
    
  );
};

export default MobileHamburger;